import React, {useEffect, useState} from 'react';
import { usePromotionsPageData } from '../hooks/usePromotionsData';
import TakisHero from "../components/TakisHero"
import TakisMediaComponent from '../components/TakisMediaComponent';
import TakisFreeText from '../components/TakisFreeText';
import TakisRecipeList from '../components/TakisRecipeList';
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton"
import TakisRecipeListSkeleton from "../components/Skeletons/TakisRecipeListSkeleton"
import TakisSocial from '../components/TakisSocial'

const Promotions = ({pagePath, pageType}) => {
  const [promotionsPageData, setPromotionsPageData] = useState('');
  const { error, isLoading, promotionsPageQueryData } = usePromotionsPageData(pagePath);

  useEffect(() => {
    if (promotionsPageQueryData) {
      setPromotionsPageData(promotionsPageQueryData);
    }
  }, [promotionsPageQueryData]);

  const getComponent = (data, key) => {
    if (data.freeText) {
      return (
        <TakisFreeText
        title={data.freeText.title}
        isSectionTitle={true}
        paragraphsFirstColumn={data.freeText.paragraphsFirstColumn}
        paragraphsSecondColumn={data.freeText.paragraphsSecondColumn}
        ctas={data.freeText.ctas}
        paragraphsTextAlign="center"
      />
      )
    }
   else if (data.mediaText) {
    return (
      <TakisMediaComponent
        key={key}
        description={data.mediaText.description}
        imageSrc={data.mediaText.desktopImage.url}
        imageMobileSrc={data.mediaText.mobileImage.url}
        imageAlt={data.mediaText.desktopImage.alt}
        caption={data.mediaText.caption}
        alignImage={data.mediaText.alignImage}
      />
      )
    }
    else if (data.social) {
      return (
        <TakisSocial data={data.social}/>
      )
    }
  }

  if (isLoading || error || !promotionsPageData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisRecipeListSkeleton/>
      </>
    );
  }

  return (
    <>
      <TakisHero data={promotionsPageData.hero}/>
      {
        promotionsPageData.content.map((componentData, index) => (
          getComponent(componentData, index)
        ))
      }
      <TakisRecipeList
        pageType={pageType}
        title={promotionsPageData.promotionsComponent.title}
        recipeCTA={promotionsPageData.promotionsComponent.recipeCTA}
        recipesPageCTA={promotionsPageData.promotionsComponent.recipesPageCTA}
        isSectionTitle={true}
      />
    </>
  );
};

export default Promotions;
